"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.uniq"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash2 = _interopRequireDefault(require("lodash.memoize"));

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _VideoDetailsModal = _interopRequireDefault(require("./VideoDetailsModal"));

var _VideoListItem = _interopRequireDefault(require("./VideoListItem"));

var _Filters = _interopRequireDefault(require("../../Filters"));

var _DeleteConfirmationModal = _interopRequireDefault(require("./DeleteConfirmationModal"));

var _ArchiveConfirmationModal = _interopRequireDefault(require("./ArchiveConfirmationModal"));

var _utils = require("../../../utils");

var _resolveProfileImages = _interopRequireDefault(require("../utils/resolveProfileImages"));

var _basePath = _interopRequireDefault(require("../../../constants/basePath"));

require("../styles/_video-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var LIST_FILTERS = {
  isArchived: [{
    label: 'Active',
    value: false
  }, {
    label: 'Archived',
    value: true
  }]
};
var CHUNK_SIZE = 16;

function getShareUrlForOutput(output) {
  if (!output) {
    return '';
  }

  if (output.status.name === 'DRAFT' || output.status.name === 'PENDING_MASTER') {
    return "".concat(window.location.origin).concat(_basePath.default, "/builder/").concat(output.videoId);
  }

  if (output.status.name === 'APPROVED') {
    return "".concat(window.location.origin).concat(_basePath.default, "/complete/").concat(output.videoId, "/").concat(output.outputId);
  }

  return "".concat(window.location.origin, "/review/").concat(output.videoId, "/").concat(output.outputId);
}

function buildStatusFilters(statuses) {
  var filterStatuses = statuses.map(function (_ref) {
    var name = _ref.name;
    return {
      label: (0, _utils.getOutputStatusLabel)(name),
      value: name
    };
  }); // group status values by labels

  var statusLabelsMap = filterStatuses.reduce(function (labelsMap, _ref2) {
    var value = _ref2.value,
        label = _ref2.label;
    return !labelsMap[label] ? _objectSpread(_objectSpread({}, labelsMap), {}, _defineProperty({}, label, value)) : _objectSpread(_objectSpread({}, labelsMap), {}, _defineProperty({}, label, [labelsMap[label], value].join(',')));
  }, {});
  return [{
    label: 'All Videos',
    value: 'ALL',
    selectedDefault: true
  }].concat(_toConsumableArray(Object.entries(statusLabelsMap).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        label = _ref4[0],
        value = _ref4[1];

    return {
      value: value,
      label: label
    };
  })));
}

var VideoList = /*#__PURE__*/function (_Component) {
  _inherits(VideoList, _Component);

  var _super = _createSuper(VideoList);

  function VideoList(props) {
    var _this;

    _classCallCheck(this, VideoList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "openArchiveModal", (0, _lodash2.default)(function (outputToArchive) {
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  outputToArchive: outputToArchive
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "fetchStats", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props, getOutputStats, videoProjectId, _yield$getOutputStats, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, getOutputStats = _this$props.getOutputStats, videoProjectId = _this$props.videoProjectId;
              _context2.next = 3;
              return getOutputStats(videoProjectId);

            case 3:
              _yield$getOutputStats = _context2.sent;
              data = _yield$getOutputStats.data;
              error = _yield$getOutputStats.error;

              if (!(!data || !data.getOutputStats || error)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                error: true
              }));

            case 8:
              _this.setState({
                stats: data.getOutputStats
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onListFiltersChange", function (_ref7) {
      var filters = _ref7.filters,
          searchTerm = _ref7.searchTerm;

      _this.setState({
        searchTerm: searchTerm,
        isShowArchived: filters.isArchived,
        displayedNum: CHUNK_SIZE,
        offset: 0
      }, _this.fetchData);
    });

    _defineProperty(_assertThisInitialized(_this), "fetchAssetsForOutputs", function (outputs) {
      var fetchAssets = _this.props.fetchAssets;
      var _this$state = _this.state,
          displayedNum = _this$state.displayedNum,
          offset = _this$state.offset;
      var relevantOutputs = outputs.slice(offset, displayedNum);
      var assetIds = (0, _lodash.default)(relevantOutputs.reduce(function (ids, output) {
        var versions = output.versions,
            latestVersion = output.latestVersion,
            video = output.video;

        var _ref8 = versions.find(function (_ref9) {
          var versionNumber = _ref9.versionNumber;
          return versionNumber === latestVersion;
        }) || {},
            assetId = _ref8.assetId;

        return [].concat(_toConsumableArray(ids), _toConsumableArray(assetId ? [assetId] : video.clips.map(function (_ref10) {
          var assetId = _ref10.assetId;
          return assetId;
        })));
      }, [])).filter(Boolean);

      if (!assetIds.length) {
        return;
      }

      fetchAssets({
        assetIds: assetIds
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateFilters", function (selectedFilters) {
      _this.setState({
        selectedFilters: selectedFilters,
        displayedNum: CHUNK_SIZE,
        offset: 0
      }, _this.fetchData);
    });

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var offset,
          postProcessor,
          _this$props2,
          getFilteredOutputs,
          videoProjectId,
          apiClient,
          _this$state2,
          searchTerm,
          selectedFilters,
          isShowArchived,
          _yield$getFilteredOut,
          data,
          error,
          _data$getFilteredOutp,
          count,
          outputs,
          withCreatorProfileImages,
          _args3 = arguments;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              offset = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 0;
              postProcessor = _args3.length > 1 ? _args3[1] : undefined;
              _this$props2 = _this.props, getFilteredOutputs = _this$props2.getFilteredOutputs, videoProjectId = _this$props2.videoProjectId, apiClient = _this$props2.apiClient;
              _this$state2 = _this.state, searchTerm = _this$state2.searchTerm, selectedFilters = _this$state2.selectedFilters, isShowArchived = _this$state2.isShowArchived;

              _this.setState({
                loading: true
              });

              _context3.next = 7;
              return getFilteredOutputs(_objectSpread(_objectSpread({}, selectedFilters), {}, {
                isArchived: isShowArchived,
                searchTerm: searchTerm,
                limit: 1000000,
                offset: offset,
                videoProjectId: videoProjectId
              }));

            case 7:
              _yield$getFilteredOut = _context3.sent;
              data = _yield$getFilteredOut.data;
              error = _yield$getFilteredOut.error;

              if (!(!data || error || !data.getFilteredOutputs)) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return", void _this.setState({
                loading: false,
                error: true
              }));

            case 12:
              _data$getFilteredOutp = data.getFilteredOutputs, count = _data$getFilteredOutp.count, outputs = _data$getFilteredOutp.outputs;

              _this.fetchAssetsForOutputs(outputs);

              _context3.next = 16;
              return (0, _resolveProfileImages.default)(outputs, apiClient);

            case 16:
              withCreatorProfileImages = _context3.sent;

              _this.setState({
                loading: false,
                count: count,
                outputs: postProcessor ? postProcessor(withCreatorProfileImages) : withCreatorProfileImages
              });

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchStatuses", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var getOutputStatuses, _yield$getOutputStatu, data, error;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              getOutputStatuses = _this.props.getOutputStatuses;
              _context4.next = 3;
              return getOutputStatuses();

            case 3:
              _yield$getOutputStatu = _context4.sent;
              data = _yield$getOutputStatu.data;
              error = _yield$getOutputStatu.error;

              if (!(!data || error || !data.getOutputStatuses)) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt("return", void _this.setState({
                error: true
              }));

            case 8:
              _this.setState({
                statuses: data.getOutputStatuses
              });

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "loadMoreResults", function () {
      var outputs = _this.state.outputs;

      if (!outputs || !outputs.length) {
        return;
      }

      _this.setState(function (_ref13) {
        var prevNum = _ref13.displayedNum,
            prevOffset = _ref13.offset;
        return {
          displayedNum: prevNum + CHUNK_SIZE,
          offset: prevOffset + CHUNK_SIZE
        };
      });

      _this.fetchAssetsForOutputs(outputs);
    });

    _defineProperty(_assertThisInitialized(_this), "createNewVideo", function () {
      var _this$props3 = _this.props,
          history = _this$props3.history,
          videoProjectId = _this$props3.videoProjectId;
      history.push('builder/new', {
        videoProjectId: videoProjectId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setVideoListRef", function (ref) {
      _this._dashboardRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "getVideoListRef", function () {
      return _this._dashboardRef;
    });

    _defineProperty(_assertThisInitialized(_this), "onTryToDeleteOutput", function (output) {
      return function () {
        _this.setState({
          outputToDelete: output
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onViewOutputDetails", function (output) {
      return function () {
        _this.setState({
          outputToView: output
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onHideModal", function () {
      _this.setState({
        outputToDelete: void 0,
        outputToView: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeArchiveModal", function () {
      _this.setState({
        outputToArchive: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onOutputArchived", function () {
      var _this$state3 = _this.state,
          outputToArchive = _this$state3.outputToArchive,
          isShowArchived = _this$state3.isShowArchived;

      _this.setState({
        outputToArchive: void 0
      }, function () {
        var action = isShowArchived ? 'unarchived' : 'archived';
        (0, _commonReact.notify)({
          content: "".concat((0, _getVideoOutputName.default)(outputToArchive, outputToArchive && outputToArchive.video.name), " successfully ").concat(action),
          type: 'success'
        });

        _this.fetchData();

        _this.fetchStats();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onOutputDeleted", function () {
      var _this$state4 = _this.state,
          outputToDelete = _this$state4.outputToDelete,
          count = _this$state4.count,
          outputs = _this$state4.outputs;

      if (!outputs || !outputToDelete) {
        return;
      }

      var newOutputs = _toConsumableArray(outputs);

      var index = outputs.findIndex(function (_ref14) {
        var outputId = _ref14.outputId;
        return outputId === outputToDelete.outputId;
      });
      newOutputs.splice(index, 1);

      _this.setState({
        outputToDelete: void 0,
        count: count ? count - 1 : 0,
        outputs: newOutputs
      }, function () {
        var video = outputToDelete.video;
        (0, _commonReact.notify)({
          content: "".concat((0, _getVideoOutputName.default)(outputToDelete, video.name), " successfully deleted."),
          type: 'success'
        });

        _this.fetchStats();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onVideoDuplicated", (0, _lodash2.default)(function (_ref15) {
      var videoId = _ref15.videoId,
          name = _ref15.name;
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var duplicateVideo, _yield$duplicateVideo, data, error;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                duplicateVideo = _this.props.duplicateVideo;
                (0, _commonReact.notify)({
                  content: "We're duplicating ".concat(name, "."),
                  type: 'info'
                });
                _context5.next = 4;
                return duplicateVideo(videoId);

              case 4:
                _yield$duplicateVideo = _context5.sent;
                data = _yield$duplicateVideo.data;
                error = _yield$duplicateVideo.error;

                if (!(!data || !data.duplicateVideo || error)) {
                  _context5.next = 9;
                  break;
                }

                return _context5.abrupt("return");

              case 9:
                (0, _commonReact.notify)({
                  content: "We've successfully duplicated ".concat(name, "."),
                  type: 'success'
                });

                _this.fetchData();

                _this.fetchStats();

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "onOutputUpdated", function (newOutput) {
      var _this$state5 = _this.state,
          outputToView = _this$state5.outputToView,
          outputs = _this$state5.outputs;

      if (!outputs || !outputToView) {
        return;
      }

      var newOutputs = _toConsumableArray(outputs);

      var index = outputs.findIndex(function (_ref17) {
        var outputId = _ref17.outputId;
        return outputId === outputToView.outputId;
      });
      newOutputs.splice(index, 1, newOutput);

      _this.setState({
        outputToView: void 0,
        outputs: newOutputs
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderVideoListItem", function (fetchCollaborationData, showShareModal) {
      return function (output) {
        var isShowArchived = _this.state.isShowArchived;
        return /*#__PURE__*/_react.default.createElement(_VideoListItem.default, {
          output: output,
          onShare: _this.onShareOutput(fetchCollaborationData, showShareModal, output),
          onDelete: _this.onTryToDeleteOutput,
          onDuplicate: _this.onVideoDuplicated,
          isShowArchived: isShowArchived,
          onToggleArchived: _this.openArchiveModal(output),
          onViewDetails: _this.onViewOutputDetails
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onShareOutput", function (fetchCollaborationData, showShareModal, output) {
      return function () {
        var shareableOutput = _this.state.shareableOutput;

        if (shareableOutput && output.videoId === shareableOutput.videoId) {
          return void showShareModal();
        }

        _this.setState({
          shareableOutput: output
        }, function () {
          fetchCollaborationData(output.video.organisationId);
          showShareModal();
        });
      };
    });

    _this.state = {
      error: false,
      selectedFilters: {},
      isShowArchived: false,
      statuses: [],
      displayedNum: CHUNK_SIZE,
      offset: 0
    };
    return _this;
  }

  _createClass(VideoList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchStats();
      this.fetchStatuses();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          containerSize = _this$props4.containerSize,
          history = _this$props4.history,
          deleteOutput = _this$props4.deleteOutput,
          headerTitle = _this$props4.headerTitle,
          headerSubtitle = _this$props4.headerSubtitle,
          headerSecondaryContent = _this$props4.headerSecondaryContent,
          headerSubtitleLink = _this$props4.headerSubtitleLink,
          headerBreadcrumbs = _this$props4.headerBreadcrumbs;
      var _this$state6 = this.state,
          selectedFilters = _this$state6.selectedFilters,
          stats = _this$state6.stats,
          outputToDelete = _this$state6.outputToDelete,
          outputToArchive = _this$state6.outputToArchive,
          shareableOutput = _this$state6.shareableOutput,
          outputToView = _this$state6.outputToView,
          statuses = _this$state6.statuses,
          error = _this$state6.error,
          loading = _this$state6.loading,
          count = _this$state6.count,
          _this$state6$outputs = _this$state6.outputs,
          outputs = _this$state6$outputs === void 0 ? [] : _this$state6$outputs,
          displayedNum = _this$state6.displayedNum,
          isShowArchived = _this$state6.isShowArchived;

      if (error) {
        return /*#__PURE__*/_react.default.createElement(_commonReact.Error, null);
      }

      var isSmall = containerSize.width < _vars.NUMERIC_MEDIA_SIZES.medium;
      var numResults = count || 0;
      var noVideosText = isShowArchived ? 'There aren\'t any archived videos.' : "".concat(selectedFilters.USER ? 'No one has' : 'You haven\'t', " created any videos yet. Use the 'Create Video' to create one.");
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "video-list page",
        ref: this.setVideoListRef
      }, /*#__PURE__*/_react.default.createElement(_VideoDetailsModal.default, {
        hideModal: this.onHideModal,
        onComplete: this.onOutputUpdated,
        output: outputToView
      }), /*#__PURE__*/_react.default.createElement(_ArchiveConfirmationModal.default, {
        visible: Boolean(outputToArchive),
        output: outputToArchive,
        isShowArchived: isShowArchived,
        onConfirmation: this.onOutputArchived,
        onClose: this.closeArchiveModal
      }), /*#__PURE__*/_react.default.createElement(_DeleteConfirmationModal.default, {
        hideModal: this.onHideModal,
        output: outputToDelete,
        deleteOutput: deleteOutput,
        onComplete: this.onOutputDeleted
      }), /*#__PURE__*/_react.default.createElement(_uiKit.PageHeader, {
        title: headerTitle,
        subtitle: headerSubtitle,
        actionBtnText: "Create Project",
        actionBtnOnClick: this.createNewVideo,
        secondaryContent: headerSecondaryContent,
        subtitleLink: headerSubtitleLink,
        breadCrumbs: headerBreadcrumbs,
        history: history
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('video-list__list-container column', {
          'video-list__list-container--medium': isSmall
        })
      }, /*#__PURE__*/_react.default.createElement(_Filters.default, {
        containerSize: containerSize,
        numResults: numResults,
        stats: stats,
        filters: {
          USER: [{
            label: 'Created by Me',
            value: 'ME',
            selectedDefault: true
          }, {
            label: 'Created by Everyone',
            value: 'ALL'
          }],
          STATUS: buildStatusFilters(statuses)
        },
        onUpdateFilters: this.onUpdateFilters
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "video-list__list-container__list"
      }, /*#__PURE__*/_react.default.createElement(_commonReact.CollaborationProvider, {
        shareUrl: getShareUrlForOutput(shareableOutput),
        resourceId: shareableOutput && shareableOutput.videoId,
        resourceName: "Video"
      }, /*#__PURE__*/_react.default.createElement(_commonReact.CollaborationConsumer, null, function (_ref18) {
        var fetchCollaborationData = _ref18.fetchCollaborationData,
            showShareModal = _ref18.showShareModal;
        return /*#__PURE__*/_react.default.createElement(_uiKit.List, {
          onFiltersChange: _this2.onListFiltersChange,
          listKey: "outputId",
          history: history,
          data: outputs.slice(0, displayedNum),
          filters: LIST_FILTERS,
          loading: loading,
          renderCardItem: _this2.renderVideoListItem(fetchCollaborationData, showShareModal),
          loadMoreResults: _this2.loadMoreResults,
          totalResults: numResults,
          getInfiniteScrollParent: _this2.getVideoListRef,
          emptyDataText: count ? 'There aren\'t any videos that match your filters.' : noVideosText
        });
      })))));
    }
  }]);

  return VideoList;
}(_react.Component);

exports.default = VideoList;